/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import { RangeControl, QueryControls, TextControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { layout, columns, query, displayPostContent, excerptLength, displayPostLink } = attributes;
		const {
			orderBy,
			order,
			selectedCategories,
			numberOfItems,
		} = query;
		const categorySuggestions = props.categories?.reduce(
			( accumulator, category ) => ( {
				...accumulator,
				[ category.name ]: category,
			} ),
			{}
		) ?? {};

		const suggestions = props.categories?.reduce(
			( accumulator, category ) => ( {
				...accumulator,
				[ category.name ]: category,
			} ),
			{}
		);
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'posts',
						initialOpen: true,
						label: () => {
							return __( 'Posts' );
						},
						cb: () => {
							return <>
								{ layouts && <div className="gutenify-template-browser">
									<h2>Templates</h2>

									<ul>
										{ layouts.map( ( template ) => {
											let classnames = 'gutenify-template-browser-item';
											if ( layout === template.name ) {
												classnames += ' gutenify-template-browser-item-active';
											}
											return <li className={ classnames } key={ template.name }>
												<button className={ `gutenify-template-browser-selector` } onClick={ () => {
													const data = {
														layout: template.name,
														socialIconAlign: template.socialIconAlign,
														imageAlign: template.imageAlign,
														titleAlign: template.titleAlign,
													};
													setAttributes( data );
													// updateInnerBlocks( template );
												} }>
													<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/post-slider-layouts/${ template.name }.png` } alt={ template.name } />
													<small>{ template.label }</small>
												</button></li>;
										} ) }
									</ul>
								</div> }
								<QueryControls
									{ ...{ orderBy, order, numberOfItems } }
									onOrderByChange={ ( newOrderBy ) => setAttributes( {
										query: {
											...query,
											orderBy: newOrderBy,
										},
									} ) }
									onOrderChange={ ( newOrder ) => setAttributes( {
										query: {
											...query,
											order: newOrder,
										},
									} ) }
									categorySuggestions={ categorySuggestions }
									selectedCategories={ selectedCategories }
									onCategoryChange={ ( tokens ) => {
										const allCategories = tokens.map( ( token ) =>
											typeof token === 'string' ? suggestions[ token ] : token
										);
										setAttributes( {
											query: {
												...query,
												selectedCategories: allCategories,
											},
										} );
									} }
									onNumberOfItemsChange={ ( newNumberOfItems ) =>
										setAttributes( {
											query: {
												...query,
												numberOfItems: newNumberOfItems,
											},
										} )
									}
								/>
								<hr />
								{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, [], props ) }
								<ToggleControl
									label={ __( 'Show content' ) }
									help={
										displayPostContent
											? __( 'Content showing' )
											: __( 'Content hidden' )
									}
									checked={ displayPostContent }
									onChange={ () => {
										setAttributes( {
											displayPostContent: ! displayPostContent,
										} );
									} }
								/>
								{ displayPostContent && <>
									<TextControl
										value={ excerptLength }
										onChange={ ( val ) => {
											setAttributes( { excerptLength: val } );
										} }
										type="number"
										min="0"
										label={ __( 'Excerpt Length' ) }
										help={ __( 'Number of words in content' ) } />

									<ToggleControl
										label={ __( 'Show Read more link' ) }
										help={
											displayPostLink
												? __( 'Read more link showing' )
												: __( 'Read more link hidden' )
										}
										checked={ displayPostLink }
										onChange={ () => {
											setAttributes( {
												displayPostLink: ! displayPostLink,
											} );
										} }
									/>
								</> }
							</>;
						},
					},
					{
						name: 'slider-options',
						initialOpen: true,
						label: () => {
							return __( 'Slider' );
						},
						cb: () => {
							return <>
								<RangeControl value={ columns } label={ __( 'Columns' ) } min={ 1 } max={ 3 } step={ 1 } onChange={ ( value ) => {
									setAttributes( { columns: value } );
								} } />
								{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--slider`, [], props ) }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
